<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.data"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.data"
                            end-label="Até"
                            range
                            start-label="Data de"
                            v-model="model.data"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!model.data.start && !model.data.end"
                            :validations="validations.hora.start"
                            @input="handleHoraStartInput"
                            label="Hora de"
                            v-model="model.hora.start"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!model.data.start && !model.data.end"
                            :validations="validations.hora.end"
                            @input="handleHoraEndInput"
                            label="Até"
                            v-model="model.hora.end"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Usuário"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.modulos"
                            @change="handleModuloChange"
                            default-option-text="Todos"
                            label="Módulo"
                            show-default-option
                            text-field="nome"
                            v-model="model.moduloId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.funcionalidades"
                            @change="handleFuncionalidadeChange"
                            default-option-text="Todas"
                            label="Funcionalidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.funcionalidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                    hide-filters
                >
                    <template v-slot:custom-foot>
                        <rkm-tr>
                            <rkm-th
                                class="text-right"
                                colspan="7"
                            >
                                Total: {{data.totalizadores.totalAcessos}}
                            </rkm-th>
                        </rkm-tr>
                    </template>
                </rkm-table>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                data: {required: true},
                hora: {
                    start: {
                        max_hour: this.model.hora.end ? this.formatTime(this.model.hora.end) : null,
                    },
                    end: {
                        min_hour: this.model.hora.start ? this.formatTime(this.model.hora.start) : null,
                    },
                },
            }
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.administracao'),
            impressao: this.getConectaSusRepository('impressao.administracao'),
            relatorioAcessoFuncionalidade: this.getConectaSusRepository('administracao.relatorioAcessoFuncionalidade'),
        }

        this.load()
    },
    data() {
        return {
            additionals: null,
            form: null,
            data: null,
            fields: [
                {key: 'data', label: 'Data', sortable: true},
                {key: 'hora', label: 'Hora', sortable: true},
                {key: 'usuarioNome', label: 'Usuário', sortable: true},
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'moduloNome', label: 'Módulo', sortable: true},
                {key: 'funcionalidadeNome', label: 'Funcionalidade', sortable: true},
            ],
            model: null,
            others: {moment},
            sortBy: 'data',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.create()
                .then((response) => {
                    this.additionals = response.data.additionals
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                moduloId: this.model.moduloId,
                funcionalidadeId: this.model.funcionalidadeId,
            }

            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.usuarios = []
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.modulos = []
            this.form.funcionalidades = []

            this.model.data = {
                start: null,
                end: null,
            }

            this.model.hora = {
                start: null,
                end: null,
            }

            this.model.usuarioId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                moduloId: this.model.moduloId,
                funcionalidadeId: this.model.funcionalidadeId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.impressao.relatorioAcessoFuncionalidade(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                moduloId: this.model.moduloId,
                funcionalidadeId: this.model.funcionalidadeId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.exportacao.relatorioAcessoFuncionalidade(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleHoraStartInput(value) {
            this.form.usuarios = []
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.modulos = []
            this.form.funcionalidades = []
            this.model.usuarioId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.data = null

            const request = {
                listar: 'usuarios',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: value,
                    end: this.model.hora.end,
                },
            }

            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.modulos = Object.assign(response.data.modulos)
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleHoraEndInput(value) {
            this.form.usuarios = []
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.modulos = []
            this.form.funcionalidades = []
            this.model.usuarioId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.data = null

            const request = {
                listar: 'usuarios',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: value,
                },
            }

            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.modulos = Object.assign(response.data.modulos)
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.modulos = []
            this.form.funcionalidades = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.data = null

            const request = {
                listar: 'unidades',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.modulos = Object.assign(response.data.modulos)
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.modulos = []
            this.form.funcionalidades = []
            this.model.infraestruturaId = null
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.data = null

            const request = {
                listar: 'infraestruturas',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.modulos = Object.assign(response.data.modulos)
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.modulos = []
            this.form.funcionalidades = []
            this.model.moduloId = null
            this.model.funcionalidadeId = null
            this.data = null

            const request = {
                listar: 'modulos',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.modulos = Object.assign(response.data.modulos)
                    this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleModuloChange() {
            this.form.funcionalidades = []
            this.model.funcionalidadeId = null
            this.data = null

            const request = {
                listar: 'funcionalidades',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                moduloId: this.model.moduloId,
            }

            this.setLoading()

            this.repositories.relatorioAcessoFuncionalidade.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.funcionalidades = Object.assign(response.data.funcionalidades))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleFuncionalidadeChange() {
            this.data = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mixins: [error, file, formats, repository, stringCase],
    watch: {
        'model.data': {
            deep: true,
            handler(value) {
                this.form.usuarios = []
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.modulos = []
                this.form.funcionalidades = []

                this.model.hora = {
                    start: null,
                    end: null,
                }

                this.model.usuarioId = null
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.moduloId = null
                this.model.funcionalidadeId = null
                this.data = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'usuarios',
                    data: {
                        start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                        end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioAcessoFuncionalidade.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.modulos = Object.assign(response.data.modulos)
                        this.form.funcionalidades = Object.assign(response.data.funcionalidades)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>